import { PlankPatternForm } from "./PlankPattern.form";

/**
 * Random stones from photos of single stones (the more photos, the more varied);
 * the size is a typical stone's. Tight lays them edge to edge with a thin joint.
 */
export const FlagstonePatternForm = ({ tight = false, ...props }: any) => (
  <PlankPatternForm
    {...props}
    pattern={tight ? "flagstonetight" : "flagstone"}
    width={{ value: "35", min: 10, max: 100, labelKey: "TILE_WIDTH" }}
    height={{ value: "35", min: 10, max: 100, labelKey: "TILE_HEIGHT" }}
    grout={tight ? "4" : "15"}
  />
);
